import type { UserDataExport } from '../../api/gdpr';

export const TEAMS_SHOWN = 5;

const locale = (language: string) => (language === 'en' ? 'en-GB' : 'nb-NO');

/** «24. mars 2025» */
export const longDate = (date: string, language: string) =>
  new Date(date).toLocaleDateString(locale(language), { day: 'numeric', month: 'long', year: 'numeric' });

/** «23.12.2025» */
export const shortDate = (date: string, language: string) =>
  new Date(date).toLocaleDateString(locale(language), { day: 'numeric', month: 'numeric', year: 'numeric' });

export const exportFilename = (today = new Date()) => {
  const pad = (value: number) => String(value).padStart(2, '0');
  return `persondata-eksport-${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}.json`;
};

/** Lagrer eksporten som en JSON-fil hos brukeren */
export const downloadExport = (data: UserDataExport) => {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = exportFilename();
  link.click();
  // Firefox og Safari trenger litt tid før adressen kan frigjøres
  setTimeout(() => URL.revokeObjectURL(url), 100);
};

export const newestFirst = <T extends object>(items: T[], date: (item: T) => string) =>
  [...items].sort((a, b) => new Date(date(b)).getTime() - new Date(date(a)).getTime());
